import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import InputFormBorder from '../Common/InputFormBorder/InputFormBorder';
import useForm from '../../helpers/useForm';
import { useTranslation } from 'react-i18next';
import ErrorBox from '../Common/ErrorBox/ErrorBox';
import ButtonProccessing, { ButtonStatus } from '../Common/ButtonProccessing/ButtonProccessing';
const CreateCardForm = ({ onSuccess, onError }) => {
  const { t } = useTranslation();
  const elements = useElements();
  const stripe = useStripe();
  const [formError, setFormError] = useState(null);
  const [btnStatus, setBtnStatus] = useState(ButtonStatus.Normal);

  const onSaveCard = async () => {
    try {
      setBtnStatus(ButtonStatus.InProgress);

      const { setupIntent, error: submitError } = await stripe.confirmSetup({
        elements,
        confirmParams: {
          payment_method_data: {
            billing_details: {
              name: values.cardHolder,
            },
          },
        },
        redirect: 'if_required',
      });

      if (submitError) {
        //errors.stripeError = submitError;
        setFormError(submitError.message);
        onError(submitError.message);
        setBtnStatus(ButtonStatus.Normal);
      } else {
        onSuccess(setupIntent);
        setBtnStatus(ButtonStatus.ProgressFinished);
      }
    } catch (error) {
      console.error(error);
      setFormError('Hubo un error inesperado.');
      onError(error.message);
      setBtnStatus(ButtonStatus.Normal);
    }
  };

  function validate(values) {
    let errors = {};

    if (!values.cardHolder) {
      errors.cardHolder = t('passwordError.PASSWORD_TOO_SHORT');
    }
    return errors;
  }

  const sendForm = async () => {
    const errors = validate(values);

    if (Object.keys(errors).length > 0) {
      setFormError(errors);
      return;
    }

    setFormError(null);
    onSaveCard();
  };

  const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  return (
    <div className='card p-2'>
      <form onSubmit={handleSubmit}>
        <InputFormBorder
          name={'cardHolder'}
          type={'text'}
          value={values.cardHolder}
          placeholder={t('bankForm.cardHolderName')}
          label={t('bankForm.cardHolderName')}
          error={errors.cardHolder}
          onChange={handleChange}
        />
        <PaymentElement />
        <ButtonProccessing
          color={'#000'}
          backgroundColor='var(--color-primary)'
          status={btnStatus}
          className={` btn mt-2`}
          text={
            <div className='bold' style={{ fontSize: '15px' }}>
              {t('addCard')}
            </div>
          }
          size='large'
        />

        {formError && (
          <div className='mt-2'>
            <ErrorBox title={formError} />
          </div>
        )}
      </form>
    </div>
  );
};

export default CreateCardForm;
